module.exports = __webpack_public_path__ + "static/img/IMG_3754.0049d90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IMG_3754.jpg
// module id = 283
// module chunks = 0